<template>
  <div class="searchContent " :style=" 'padding:'+(data.style.paddingTB*0.9)+'px '+(data.style.paddingLR*0.9) +'px'">
      <div class="searchForm"  :style=" {borderColor: data.style.themeColor}">
        <div ><SearchOutlined :style="'color:'+data.style.themeColor"  /><span>{{data.params.placeholder}}</span></div>
        <div class="searchBtn"  :style=" {backgroundColor: data.style.themeColor}">搜索</div>
      </div>
  </div>
</template>

<script>
import {SearchOutlined} from "@ant-design/icons-vue";
export default {
   props: { data: Object },
  components: { SearchOutlined},
  setup(){
  }
}
</script>
<style lang="less" scoped>
.searchContent{
  padding: 0 10px;
  top:0;
  .searchForm{
    font-size: 13px;
    border-radius: 30px;
    height: 30px;
    background: #fff;
    overflow: hidden;
    border: 2px solid #F85F24;
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 10px;
    justify-content: space-between;
    overflow: hidden;
    span{
      color: #8E8E8E;
      margin-left: 5px;
    }
    .searchBtn{
      color: #fff;
      height: 110%;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      background-color:  #F85F24;
    }
  }
}
</style>